import { WALLET_PROVIDER } from '../../../../constants/wallet.constants';
import bitgoIcon from '../../../../assets/icons/bitgo.svg';
import metamaskIcon from '../../../../assets/icons/metamask.svg';

const PROVIDER_ICON_MAP = {
  [WALLET_PROVIDER.BITGO]: bitgoIcon,
  [WALLET_PROVIDER.METAMASK]: metamaskIcon,
};

export const getWalletProviderIcon = (wallet) => {
  const provider = String(wallet?.provider ?? '').toLowerCase();
  if (PROVIDER_ICON_MAP[provider]) return PROVIDER_ICON_MAP[provider];

  const typeLabel = String(wallet?.walletTypeLabel ?? '').toLowerCase();
  if (typeLabel.includes('metamask')) return metamaskIcon;
  if (typeLabel.includes('bitgo')) return bitgoIcon;

  const rawType = String(
    wallet?.raw?.walletType ??
      wallet?.raw?.wallet_type ??
      wallet?.raw?.provider ??
      '',
  ).toLowerCase();

  if (rawType.includes('metamask')) return metamaskIcon;
  if (rawType.includes('bitgo')) return bitgoIcon;

  return null;
};
